import { createSlice } from '@reduxjs/toolkit';
import { logout } from '../globalAction';

const initialState = {
  filterData: null,
  activeTabPro: 'General Info',
  docActiveTabPro: 1,
  isManager: false
};
const ProjectSlice = createSlice({
  name: 'ProjectSlice',
  initialState,

  reducers: {
    updateFilters: (state, actions) => {
      if (actions) {
        state.filterData = actions?.payload;
      }
    },
    updateActiveTabPro: (state, actions) => {
      state.activeTabPro = actions?.payload;
    },
    updateDocActiveTabPro: (state, actions) => {
      state.docActiveTabPro = actions?.payload;
    },
    updateIsManager: (state, actions) => {
      state.isManager = actions?.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => ({ ...initialState }));
  }
});
export const { updateFilters, updateActiveTabPro, updateDocActiveTabPro, updateIsManager } =
  ProjectSlice.actions;
export default ProjectSlice.reducer;
